export default "__VITE_ASSET__bSufv0Y0__"